var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFood({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 14H15V3.2C15.9 3.5 17 4.5 17 7V14ZM16 21H15V15H16V21ZM14 2V22H17V15H18V7C18 4.2 16.8 2 14 2Z",
    fill: "#3936EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10V2H10V6H9V2H8V6H7V2H6V10H8V14H7V22H10V14H9V10H11ZM9 21H8V15H9V21ZM7 9V7H10V9H7Z",
    fill: "#3936EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFood);
export default __webpack_public_path__ + "static/media/Food.239ec75fc7bdf8469269b4553cd5c90a.svg";
export { ForwardRef as ReactComponent };